import http from '@/assets/js/common/http-common';

class UserDataService {
  
    create(data) {
      return http.post('usuario/create', data);
    }

    read(id) {
      return http.post('usuario/read', {id:id});
    }
  
    update(data) {
      return http.post('usuario/update', data);
    }

    changePwd(data) {
      return http.post('usuario/changePwd', data);
    }

    listTurmas() {
      return http.post('usuario/turmas', null);
    }

    listTurmaAlunos(data) {
      return http.post('usuario/turmas/alunos', data);
    }

    listProfessores() {
      return http.get('usuario/professores');
    }

    listProfessorDisciplinasTurmas(data = null) {
      if (data === null) {
        return http.get('usuario/professores/disciplinas-turmas');
      }
      return http.post('usuario/professores/disciplinas-turmas', data);
    }

    sistemaUsuarios() { return http.get('usuario/sistema/usuarios'); }
    sistemaUsuarioCreate(data) { return http.post('usuario/sistema/usuarios/create', data); }
    sistemaUsuarioUpdate(data) { return http.post('usuario/sistema/usuarios/update', data); }
    sistemaUsuarioDelete(id) { return http.post('usuario/sistema/usuarios/delete', { id }); }

    sistemaAlunos() { return http.get('usuario/sistema/alunos'); }
    sistemaAlunoCreate(data) { return http.post('usuario/sistema/alunos/create', data); }
    sistemaAlunoUpdate(data) { return http.post('usuario/sistema/alunos/update', data); }
    sistemaAlunoDelete(alunoId) { return http.post('usuario/sistema/alunos/delete', { aluno_id: alunoId }); }
    sistemaAlunoInvite(alunoId) { return http.post('usuario/sistema/alunos/invite', { aluno_id: alunoId }); }

    sistemaDisciplinas() { return http.get('usuario/sistema/disciplinas'); }
    sistemaPeriodosCurriculares() { return http.get('usuario/sistema/periodos-curriculares'); }
    sistemaPeriodosLetivos() { return http.get('usuario/sistema/periodos-letivos'); }
    sistemaPeriodoLetivoSave(data) { return http.post('usuario/sistema/periodos-letivos/save', data); }
    sistemaTurmasPeriodos() { return http.get('usuario/sistema/turmas-periodos'); }
    sistemaTurmaPeriodoSave(data) { return http.post('usuario/sistema/turmas-periodos/save', data); }
    sistemaOfertas() { return http.get('usuario/sistema/ofertas'); }
    sistemaDisciplinaCreate(data) { return http.post('usuario/sistema/disciplinas/create', data); }
    sistemaDisciplinaUpdate(data) { return http.post('usuario/sistema/disciplinas/update', data); }
    sistemaDisciplinaDelete(id) { return http.post('usuario/sistema/disciplinas/delete', { id }); }

    sistemaTurmaSave(data) { return http.post('usuario/sistema/turmas/update', data); }

    sistemaVinculos() { return http.get('usuario/sistema/vinculos'); }
    sistemaVinculoCreate(data) { return http.post('usuario/sistema/vinculos/create', data); }
    sistemaVinculoUpdate(data) { return http.post('usuario/sistema/vinculos/update', data); }
    sistemaVinculoDelete(id) { return http.post('usuario/sistema/vinculos/delete', { id }); }

}

export default new UserDataService();
